module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-shenzhen.4065ebbb.mp4";